// extracted by mini-css-extract-plugin
export default {"native":"PSsm68","label":"ZP_gER"};